import { useEffect, useState } from 'react';
import {
  Box,
  Chip,
  TextField,
  Autocomplete,
  Paper,
  useTheme,
} from '@mui/material';
import toastError from '../../toasts/toastError';
import api from '../../services/api';
import { i18n } from '../../translate/i18n';

export function UsersFilter({ onFiltered, initialUsers }) {
  const theme = useTheme();
  const [users, setUsers] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await api.get(`/users/list`);
        const userList = data
          .map((u) => ({ name: u.name, id: u.id }))
          .sort((a, b) => a.name.localeCompare(b.name));
        setUsers(userList);
      } catch (err) {
        toastError(err);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const select = async () => {
      if (
        Array.isArray(initialUsers) &&
        Array.isArray(users) &&
        users.length > 0
      ) {
        setSelecteds(initialUsers);
      }
    };
    select();
  }, [initialUsers, users]);

  const onChange = (event, value) => {
    setSelecteds(value);
    onFiltered(value);
  };

  return (
    <Box style={{ padding: '2.5px 10px' }}>
      <Autocomplete
        multiple
        size='small'
        options={users}
        value={selecteds}
        onChange={onChange}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => {
            const { key, ...tagProps } = getTagProps({ index });
            return (
              <Chip
                key={key}
                variant='outlined'
                sx={{
                  backgroundColor: '#181c35',
                  textShadow: '1px 1px 1px #000',
                  color: '#FFF',
                }}
                label={option.name}
                {...tagProps}
                size='small'
              />
            );
          })
        }
        renderInput={(params) => (
          <TextField
            {...params}
            variant='outlined'
            placeholder={i18n.t('tickets.search.filterUsers')}
            sx={theme.custom.selectField}
          />
        )}
        PaperComponent={({ children }) => (
          <Paper
            sx={{
              backgroundColor: theme.custom.colors.defaultBackground,
              '& .MuiAutocomplete-listbox': {
                color: theme.custom.colors.text,
              },
            }}
          >
            {children}
          </Paper>
        )}
      />
    </Box>
  );
}
